/* eslint-disable */
export default class Currency {
  moneyWithCommas(initialValue) {
    return initialValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
